import React from "react";
import styles from "./BillingCard.module.css";
import TextComponent from "../textComponent/TextComponent";
import { FaRegCheckCircle } from "react-icons/fa";
import SubmitButton from "../submitButton/SubmitButton";
import { useLocation, useNavigate } from "react-router-dom";

const BillingCard = ({ Options, isNavigate, onClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={styles.CardList}>
      {Options?.map((item, index) => (
        <div className={styles.Card} key={index}>
          <div className={styles.CardHeader}>
            <img
              src={item?.logo}
              alt={item?.title}
              className={styles.Cardlogo}
            />
            <TextComponent text={item?.title} className={styles.Title} />
          </div>

          <div className={styles.PriceRow}>
            <TextComponent
              fontFamily={"Inter-medium"}
              className={styles.price}
              text={"$7 "}
              padding={"0px"}
            />
            <TextComponent
              text={"/User month"}
              className={styles.month}
              fontSize={15}
              padding={"0px"}
            />
          </div>

          <div className={styles.CardSubList}>
            {item?.list?.map((element, idx) => (
              <div className={styles.list} key={idx}>
                <FaRegCheckCircle color="#EF710A" size={18} />
                <TextComponent text={element} className={styles.ItemText} />
              </div>
            ))}
          </div>
          {/* 
          <SubmitButton
            title={"Choose Plan"}
            btnClass={styles.BtnCard}
            primary
            onClick={
              isNavigate
                ? () => navigate("/AdminBuisnessManagement/SelectPaymentMethod")
                : undefined
            }
          /> */}

          {isNavigate ? (
            <SubmitButton
              title={
                location.pathname ==
                "/AdminBuisnessManagement/BillingSubscription"
                  ? "Cancel Plan"
                  : "Choose Plan"
              }
              btnClass={styles.BtnCard}
              primary
              // onClick={() => navigate("/AdminPayments")}
              onClick={onClick}
            />
          ) : (
            <SubmitButton
              title={"Choose Plan"}
              btnClass={styles.BtnCard}
              primary
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default BillingCard;
